// extracted by mini-css-extract-plugin
export default {"root":"SettingText_root__Ui31Y","small":"SettingText_small__C6D43","large":"SettingText_large__viya6","top":"SettingText_top__bVRK3","bottom":"SettingText_bottom__ZJsgs"};